export default __webpack_public_path__ + "static/media/enotes.556d8347.png";